(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canvas = document.getElementById('starfield');
  const ctx = canvas ? canvas.getContext('2d') : null;
  const parallaxEls = Array.from(document.querySelectorAll('.parallax'));
  const mouse = { x: .5, y: .5 };
  let stars = [];
  let dpr = Math.min(window.devicePixelRatio || 1, 2);
  let animationFrame = null;
  let pageVisible = !document.hidden;

  function resizeStarfield() {
    if (!canvas || !ctx) return;
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const mobileFactor = window.innerWidth < 760 ? .11 : .2;
    const count = Math.round(Math.min(360, window.innerWidth * mobileFactor));
    stars = Array.from({ length: count }, () => ({
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      r: Math.random() * 1.35 + .15,
      a: Math.random() * .66 + .2,
      d: Math.random() * 1.55 + .18,
      t: Math.random() * Math.PI * 2
    }));
  }

  function drawStarfield(t = 0) {
    if (!ctx || !pageVisible) return;
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    for (const s of stars) {
      const ox = reducedMotion ? 0 : (mouse.x - .5) * s.d * 9;
      const oy = reducedMotion ? 0 : (mouse.y - .5) * s.d * 9;
      const twinkle = reducedMotion ? 1 : (.72 + Math.sin(t * .001 + s.t) * .28);
      ctx.beginPath();
      ctx.fillStyle = `rgba(185,225,255,${s.a * twinkle})`;
      ctx.arc(s.x + ox, s.y + oy, s.r, 0, Math.PI * 2);
      ctx.fill();
    }
    if (!reducedMotion) animationFrame = requestAnimationFrame(drawStarfield);
  }

  if (canvas && ctx) {
    resizeStarfield();
    window.addEventListener('resize', resizeStarfield, { passive: true });
    if (reducedMotion) drawStarfield(0); else animationFrame = requestAnimationFrame(drawStarfield);
    document.addEventListener('visibilitychange', () => {
      pageVisible = !document.hidden;
      if (!pageVisible && animationFrame) cancelAnimationFrame(animationFrame);
      if (pageVisible && !reducedMotion) animationFrame = requestAnimationFrame(drawStarfield);
    });
  }

  if (!reducedMotion) {
    window.addEventListener('pointermove', e => {
      mouse.x = e.clientX / window.innerWidth;
      mouse.y = e.clientY / window.innerHeight;
      parallaxEls.forEach(el => {
        const depth = Number(el.dataset.depth || 10);
        el.style.setProperty('--px', ((mouse.x - .5) * depth) + 'px');
        el.style.setProperty('--py', ((mouse.y - .5) * depth) + 'px');
      });
    }, { passive: true });
  }

  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !reducedMotion) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: .14 });
    revealEls.forEach(el => observer.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('visible'));
  }

  const heroBook = document.getElementById('heroBook');
  const hero = document.querySelector('.hero');
  const specular = heroBook ? heroBook.querySelector('.book-specular') : null;
  let hoveringBook = false;

  function setBookFromScroll() {
    if (!heroBook || !hero || hoveringBook || reducedMotion) return;
    const p = Math.min(1, window.scrollY / hero.offsetHeight);
    heroBook.style.transform = `rotateY(${-7 + p * 10}deg) rotateX(${2 - p * 3}deg) translate3d(${p * 18}px,${22 + p * 54}px,0) rotateZ(${-0.5 + p * 1.8}deg)`;
    if (specular) specular.style.opacity = String(.58 - p * .24);
  }

  function updateOpenBook() {
    if (reducedMotion) return;
    const openScene = document.getElementById('openBookScene');
    const openBook = document.getElementById('openBook');
    if (!openScene || !openBook) return;
    const r = openScene.getBoundingClientRect();
    const p = Math.max(0, Math.min(1, (window.innerHeight - r.top) / (window.innerHeight + r.height)));
    openBook.style.transform = `rotateX(${14 - p * 8}deg) rotateZ(${-7 + p * 7}deg) translateY(${(1 - p) * 35}px)`;
  }

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => { setBookFromScroll(); updateOpenBook(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });
  setBookFromScroll();
  updateOpenBook();

  if (heroBook && !reducedMotion) {
    heroBook.addEventListener('pointermove', e => {
      hoveringBook = true;
      const r = heroBook.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - .5;
      const y = (e.clientY - r.top) / r.height - .5;
      heroBook.style.transform = `rotateY(${x * 12 - 5}deg) rotateX(${-y * 8 + 1}deg) translate3d(${x * 8}px,20px,18px) rotateZ(${x * 1.2}deg)`;
      if (specular) {
        specular.style.transform = `translate3d(${x * 18}px,${y * 10}px,32px)`;
        specular.style.opacity = '.76';
      }
    });
    heroBook.addEventListener('pointerleave', () => {
      hoveringBook = false;
      if (specular) specular.style.transform = 'translateZ(32px)';
      setBookFromScroll();
    });
  }

  const modal = document.getElementById('trailerModal');
  const closeButton = modal ? modal.querySelector('.modal-close') : null;
  const trailerFrame = modal ? modal.querySelector('.trailer-frame') : null;
  let lastFocused = null;

  function openModal(trigger) {
    if (!modal) return;
    lastFocused = trigger || document.activeElement;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (trailerFrame && trailerFrame.dataset.src) trailerFrame.src = trailerFrame.dataset.src;
    if (closeButton) closeButton.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (trailerFrame) trailerFrame.removeAttribute('src');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  document.querySelectorAll('.trailer-trigger').forEach(btn => btn.addEventListener('click', () => openModal(btn)));
  if (closeButton) closeButton.addEventListener('click', closeModal);
  if (modal) modal.addEventListener('click', e => { if (e.target === modal) closeModal(); });
  window.addEventListener('keydown', e => {
    if (e.key === 'Escape' && modal && modal.classList.contains('open')) closeModal();
  });

  const menuButton = document.querySelector('.menu-button');
  const mobileMenu = document.getElementById('AuroraMobileMenu');
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
    });
    mobileMenu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      mobileMenu.hidden = true;
      menuButton.setAttribute('aria-expanded', 'false');
    }));
  }

  document.documentElement.classList.remove('no-js');
})();
